"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const assets_1 = require("../../api/assets");
const ecommerce_1 = require("../../api/ecommerce");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const configuration_1 = __importDefault(require("../apis/configuration/assets/configuration"));
const configuration_2 = __importDefault(require("../apis/configuration/shop/configuration"));
const UiStore_1 = __importDefault(require("./UiStore"));
class NotificationStore {
    shopApi = new ecommerce_1.NotificationApi(configuration_2.default);
    assetsApi = new assets_1.NotificationsApi(configuration_1.default);
    onRefreshNotificationsReaction = null;
    notificationsList = [];
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            notificationsList: mobx_1.observable,
            hasNotifications: mobx_1.computed,
            hasRequiredPermissions: mobx_1.computed,
            loadNotifications: mobx_1.action.bound,
            notificationsCount: mobx_1.computed,
            notifications: mobx_1.computed,
        });
    }
    get hasNotifications() {
        return this.notificationsList.length > 0;
    }
    get hasRequiredPermissions() {
        return [AuthorizationScopes_1.default.LICENSE_READ, AuthorizationScopes_1.default.OFFER_READ].some((scope) => AuthorizationStore_1.default.hasScope(scope));
    }
    initialize() {
        if (null === this.onRefreshNotificationsReaction) {
            this.onRefreshNotificationsReaction = (0, mobx_1.reaction)(() => [UiStore_1.default.sixtySeconds, AuthorizationStore_1.default.customerId, AuthorizationStore_1.default.user], () => {
                if (AuthorizationStore_1.default.user) {
                    this.loadNotifications();
                }
            }, { fireImmediately: true });
        }
    }
    loadNotifications() {
        if (!this.hasRequiredPermissions) {
            return new Promise((0, mobx_1.action)((resolve) => {
                resolve((this.notificationsList = []));
            }));
        }
        return Promise.all([this.shopApi.listsNotifications(), this.assetsApi.getNotifications()])
            .then((results) => results.reduce((carry, items) => carry.concat(items), []))
            .then((0, mobx_1.action)((notificationsList) => (this.notificationsList = notificationsList)));
    }
    get notificationsCount() {
        return this.notificationsList.length;
    }
    get notifications() {
        return this.notificationsList;
    }
}
exports.default = new NotificationStore();
